import { gql, TypedDocumentNode } from "@apollo/client";

import {
  CreateBlackListRuleMutation,
  CreateBlackListRuleMutationVariables,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { ruleFragment } from "src/graphql/anti-fraud/fragments/RuleFragment";

export const createRuleMutation = gql`
  mutation CreateBlackListRule(
    $code: String!
    $name: String!
    $description: String!
    $identifierPath: IdentifierPathInput!
    $listElementType: String!
    $caseTypeCode: String!
    $blackListElementConditions: [BlackListElementConditionInput!]
    $multiValueConditions: [BlackListElementMultiValueConditionInput!]
  ) {
    createBlackListRule(
      input: {
        code: $code
        name: $name
        description: $description
        identifierPath: $identifierPath
        listElementType: $listElementType
        caseTypeCode: $caseTypeCode
        blackListElementConditions: $blackListElementConditions
        multiValueConditions: $multiValueConditions
      }
    ) {
      ...RuleFragment
    }
  }

  ${ruleFragment}
` as TypedDocumentNode<CreateBlackListRuleMutation, CreateBlackListRuleMutationVariables>;
